import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useUser, useClerk } from '@clerk/clerk-react'
import AdminManagement from './AdminManagement'
import OrderViewer from './OrderViewer'
import Roles from './admin/Roles'
import useSessionStorage from '../hooks/useSessionStorage'
import { useStore } from '../context/StoreContext'

export default function AdminPanel() {
  const navigate = useNavigate()
  const { isLoaded, isSignedIn, user } = useUser();
  const { signOut } = useClerk();
  const { setIsAdmin,setIsLoading } = useStore();
  const [activeTab, setActiveTab] = useSessionStorage("activeTab", "management");

  useEffect(() => {
    if (!isLoaded) {
      setIsLoading(true);
      return;
    }
    
    setIsLoading(false);

    if (!isSignedIn) {
      navigate('/adminlogin');
      return;
    }

    const role = user?.publicMetadata?.role || 'user';
    if (role !== 'admin' && role !== 'superadmin') {
      setIsAdmin(false);
      navigate('/');
    } else {
      setIsAdmin(true);
    }
  }, [isLoaded, isSignedIn, user, navigate, setIsAdmin, setIsLoading]);

  const handleLogout = () => {
    setIsAdmin(false);
    signOut(() => navigate('/'));
  }

  // Show nothing while loading or redirecting (global Loading component will show)
  if (!isLoaded) {
    return null;
  }

  // If not signed in or not admin, show nothing (useEffect will redirect)
  if (!isSignedIn || !['admin', 'superadmin'].includes(user?.publicMetadata?.role)) {
    return null;
  }

  return (
    <div className='container mt-3'>
      <ul className="nav nav-tabs">
        <li className="nav-item">
          <button 
            className={`nav-link ${activeTab === 'management' ? 'active' : ''} text-black-important`} 
            onClick={() => setActiveTab('management')}
            style={{cursor:'pointer'}}
          >
            Management
          </button>
        </li>
        <li className="nav-item">
          <button 
            className={`nav-link ${activeTab === 'orders' ? 'active' : ''} text-black-important`} 
            onClick={() => setActiveTab('orders')}
            style={{cursor:'pointer'}}
          >
            Orders
          </button>
        </li>
        <li className="nav-item">
          <button 
            className={`nav-link ${activeTab === 'roles' ? 'active' : ''} text-black-important`} 
            onClick={() => setActiveTab('roles')}
            style={{cursor:'pointer'}}
          >
            Roles
          </button>
        </li>
      </ul>

      <div className='tab-content border-start border-end border-bottom p-3 bg-light'>
        {activeTab === 'management' && <AdminManagement />}
        {activeTab === 'orders' && <OrderViewer />}
        {activeTab === 'roles' && <Roles />}
      </div>

      <div className='logoutbtn mt-3'>
        <button className="btn btn-danger" onClick={handleLogout}>Logout</button>
      </div>
    </div>
  )
}